var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanCareNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 14.1663V9.63301C28.3334 7.25278 28.3334 6.06267 27.8702 5.15355C27.4627 4.35386 26.8126 3.70369 26.0129 3.29623C25.1038 2.83301 23.9136 2.83301 21.5334 2.83301H12.4667C10.0865 2.83301 8.89641 2.83301 7.98729 3.29623C7.1876 3.70369 6.53743 4.35386 6.12997 5.15355C5.66675 6.06267 5.66675 7.25278 5.66675 9.63301V24.3663C5.66675 26.7466 5.66675 27.9367 6.12997 28.8458C6.53743 29.6455 7.1876 30.2957 7.98729 30.7031C8.89641 31.1663 10.0865 31.1663 12.4667 31.1663H17.0001M17.7084 15.583H11.3334M12.7501 21.2497H11.3334M22.6667 9.91634H11.3334M24.0795 21.0097C22.9466 19.7219 21.0573 19.3755 19.6377 20.5547C18.2182 21.7339 18.0184 23.7055 19.1331 25.1001C20.2479 26.4947 24.0795 29.7497 24.0795 29.7497C24.0795 29.7497 27.9112 26.4947 29.0259 25.1001C30.1407 23.7055 29.9653 21.7215 28.5213 20.5547C27.0774 19.3879 25.2125 19.7219 24.0795 21.0097Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanCareNotes);
export default __webpack_public_path__ + "static/media/carePlanCareNotes.7f0ce48c780f426b3d19a4051938f9a5.svg";
export { ForwardRef as ReactComponent };